import React,{useEffect} from 'react'
import { useDispatch, useSelector } from "react-redux";

import { fetchMe} from "../../redux/slice/authSlice";
const Points = () => {
    const dispatch = useDispatch();
    const { personalDetail } = useSelector(({ auth }) => auth);
    useEffect(() => {
      // Guard against firing while there's no token (e.g. mid sign-out) —
      // an unauthenticated fetchMe() 401s, which can trigger the axios
      // interceptor's token-refresh path and re-write "token"/"user" back
      // into localStorage right after logout just cleared them.
      if (!localStorage.getItem("token")) return;
      dispatch(fetchMe({}));
       updateLocalStorage()
    }, [dispatch]);

    const updateLocalStorage = () => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (!storedUser) return;
      const updatedUser = {
        ...storedUser,  
        data: {
          ...storedUser?.data,   
          user: {
            ...storedUser?.data?.user,   
            ...personalDetail,  
          },
        },
      };
    
      localStorage.setItem("user", JSON.stringify(updatedUser));
      //setUser(JSON.parse(userData));
    };
  return (
    <span>{personalDetail?.balance ?? 0}</span>
  )
}

export default Points
